/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ApiRequestsCostInput } from '../models';
// @ts-ignore
import { ApiRequestsCostOutput } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
/**
 * HuggingfaceApi - axios parameter creator
 * @export
 */
export const HuggingfaceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Given requestIds - returns their cost in nano-USD
         * @summary Requests cost
         * @param {ApiRequestsCostInput} [apiRequestsCostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestsCost: async (apiRequestsCostInput?: ApiRequestsCostInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/requestsCost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiRequestsCostInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HuggingfaceApi - functional programming interface
 * @export
 */
export const HuggingfaceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HuggingfaceApiAxiosParamCreator(configuration)
    return {
        /**
         * Given requestIds - returns their cost in nano-USD
         * @summary Requests cost
         * @param {ApiRequestsCostInput} [apiRequestsCostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequestsCost(apiRequestsCostInput?: ApiRequestsCostInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiRequestsCostOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequestsCost(apiRequestsCostInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HuggingfaceApi.getRequestsCost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * HuggingfaceApi - factory interface
 * @export
 */
export const HuggingfaceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HuggingfaceApiFp(configuration)
    return {
        /**
         * Given requestIds - returns their cost in nano-USD
         * @summary Requests cost
         * @param {HuggingfaceApiGetRequestsCostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestsCost(requestParameters: HuggingfaceApiGetRequestsCostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiRequestsCostOutput> {
            return localVarFp.getRequestsCost(requestParameters.apiRequestsCostInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HuggingfaceApi - interface
 * @export
 * @interface HuggingfaceApi
 */
export interface HuggingfaceApiInterface {
    /**
     * Given requestIds - returns their cost in nano-USD
     * @summary Requests cost
     * @param {ApiRequestsCostInput} [apiRequestsCostInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HuggingfaceApiInterface
     */
    getRequestsCost(apiRequestsCostInput?: ApiRequestsCostInput, options?: RawAxiosRequestConfig): AxiosPromise<ApiRequestsCostOutput>;

}

/**
 * Request parameters for getRequestsCost operation in HuggingfaceApi.
 * @export
 * @interface HuggingfaceApiGetRequestsCostRequest
 */
export interface HuggingfaceApiGetRequestsCostRequest {
    /**
     * 
     * @type {ApiRequestsCostInput}
     * @memberof HuggingfaceApiGetRequestsCost
     */
    readonly apiRequestsCostInput?: ApiRequestsCostInput
}

/**
 * HuggingfaceApi - object-oriented interface
 * @export
 * @class HuggingfaceApi
 * @extends {BaseAPI}
 */
export class HuggingfaceApi extends BaseAPI implements HuggingfaceApiInterface {
    /**
     * Given requestIds - returns their cost in nano-USD
     * @summary Requests cost
     * @param {HuggingfaceApiGetRequestsCostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HuggingfaceApi
     */
    public getRequestsCost(requestParameters: HuggingfaceApiGetRequestsCostRequest = {}, options?: RawAxiosRequestConfig) {
        return HuggingfaceApiFp(this.configuration).getRequestsCost(requestParameters.apiRequestsCostInput, options).then((request) => request(this.axios, this.basePath));
    }
}

